import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Navbar from './views/Navbar.vue';
import Footer from './views/Footer.vue';
import LangugeSwitcher from './views/Languageswitch.vue';
import store from './store';
import axios from 'axios';
//axios.defaults.baseURL = 'http://localhost:8000';
axios.defaults.baseURL = 'https://iseteenindus-api.tenniseklubi.ee';
Vue.prototype.$http = axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['token'] = token
}
Vue.prototype.$apiURL = axios.defaults.baseURL;
/* Components */
Vue.component('languageswitcher', LangugeSwitcher);
Vue.component('navbar', Navbar);
Vue.component('app-footer', Footer);

import Pagetitle from './views/Pagetitle.vue';
Vue.component('Pagetitle', Pagetitle);

// languages
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#111111', // #E53935
    secondary: colors.red.lighten4, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
});
import 'vuetify/dist/vuetify.min.css';

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import { languages } from './i18n/index.js';
import { defaultLocale } from './i18n/index.js';
const messages = Object.assign(languages);
var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'et',
  messages
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js